

const state = {
  type: null,
  cityId: 0,
  jieguo: [],
  qiangzhijieguoVisible: false
}
const mutations = {
  setType(state, payload) {
    state.type = payload
  },
  setCityId(state, payload) {
    state.cityId = payload
  },
  setjieguo(state, payload) {
    state.jieguo = payload
  },
  setQiangzhijieguoVisible(state, payload) {
    state.qiangzhijieguoVisible = payload
  }
}
const actions = {
  setType({ commit }, payload) {
    state.step = payload
    commit('setType', payload)
  },
  setCityId({ commit }, payload) {
    commit('setCityId', payload)
    state.step = payload
  },
  setjieguo({ commit }, payload) {
    commit('setjieguo', payload)
    state.step = payload
  },
  clearData({ commit }) {
    commit('setType', null)
    commit('setCityId', 0)
    commit('setjieguo', [])
  },
  setQiangzhijieguoVisible({ commit }, payload) {
    commit('setQiangzhijieguoVisible', payload)
  }
}
export default {
  namespaced: true,
  state,
  actions,
  mutations
}